import { inject, InjectionToken } from '@angular/core';
import { LOCAL_STORAGE } from '../tokens';

export const AUTH_TOKEN_STORAGE_KEY = new InjectionToken<string>('Localstorage key to save token', {
  providedIn: 'root',
  factory: () => {
    return 'auth';
  },
});

export const AUTH_STORAGE = new InjectionToken<Storage>('Token storage', {
  providedIn: 'root',
  factory: (): Storage => {
    return inject(LOCAL_STORAGE);
  },
});

export const AUTH_REDIRECT_URL = new InjectionToken<string>(
  'Url that defines where to redirect if user is not authorized'
);

export const AUTH_TOKEN_URL = new InjectionToken<string>('Url that defines where to get token from backend');

export const AUTH_API_URL = new InjectionToken<string>('App api url');
